import React from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { routes } from './helper/routes';
import { darkTheme } from './styles/themes';
import Root from './components/Root';

const App = (): JSX.Element =>
(
  <Router >
    <Routes>
      {
        routes.map((r, i) =>
          <Route
            key={i}
            path={r.path}
            element={(<Root theme={darkTheme} children={r.element}/>)} />)
      }
    </Routes>
  </Router>
  
);


export default App;
